import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import type { GetShippingResponse } from '~/api/product-page/types'

export const useDeliveryBeforeChristmas = (
  shipping?: MaybeRefOrGetter<
    | GetShippingResponse
    | NonNullable<GetPickersResponse['selectedOffer']>['shipping']
    | null
  >,
) => {
  const deliveryBeforeChristmasTimeFrame = {
    from: Date.parse(`01 Dec ${new Date().getFullYear()} 00:00:00 UTC`),
    to: Date.parse(`23 Dec ${new Date().getFullYear()} 23:59:59 UTC`),
  }

  const isChristmasTime = computed(() => {
    return (
      Date.now() > deliveryBeforeChristmasTimeFrame.from &&
      Date.now() < deliveryBeforeChristmasTimeFrame.to
    )
  })

  const isStandardDeliveryBeforeChristmas = computed(() => {
    const value = toValue(shipping)

    return (
      (isChristmasTime.value &&
        value?.free &&
        new Date(value.free.latestArrivalDate).valueOf() <
          deliveryBeforeChristmasTimeFrame.to) ??
      false
    )
  })

  const isExpressDeliveryBeforeChristmas = computed(() => {
    const value = toValue(shipping)

    return (
      (isChristmasTime.value &&
        value?.express &&
        new Date(value.express.latestArrivalDate).valueOf() <
          deliveryBeforeChristmasTimeFrame.to) ??
      false
    )
  })

  const hasDeliveryBeforeChristmas = computed(() => {
    return (
      isStandardDeliveryBeforeChristmas.value ||
      isExpressDeliveryBeforeChristmas.value
    )
  })

  return {
    isStandardDeliveryBeforeChristmas,
    isExpressDeliveryBeforeChristmas,
    hasDeliveryBeforeChristmas,
    isChristmasTime,
  }
}
